export default __webpack_public_path__ + "static/tea1-d58e549dfe0dca404b8d8a14426a8549.png";